import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown, faEdit, faSearch, faTimes, faCopy, faLink, faPlus, faList,
  faFileDownload, faVideo, faBuilding, faLock, faUnlock, faExpandArrowsAlt, faMapMarkerAlt,
  faPen, faCaretLeft, faCaretRight, faCaretUp, faArrowDown, faArrowUp, faArrowRight, faArrowLeft,
  faSync, faExternalLinkAlt, faStar, faExclamationCircle, faCheckCircle, faInfoCircle, faBan,
  faCog, faComment, faBook, faFill, faHistory, faChevronLeft, faLocationArrow, faSpinner,
  faSave, faCheck, faListUl, faExpand, faCompress, faAngleDoubleRight, faAngleDoubleLeft,
  faPortrait, faSlidersH, faClipboardList, faEllipsisV, faFont, faDrawPolygon, faWaveSquare,
  faVectorSquare, faRoad, faSatellite, faCalculator, faRulerCombined, faCircle as fasCircle,
  faExclamationTriangle, faQuestionCircle, faServer, faTimesCircle, faNetworkWired,
  faSquare as fasSquare, faLongArrowAltLeft, faLongArrowAltRight, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faImage, faFileArchive, faFileWord, faFilePowerpoint, faFilePdf,
  faFileExcel, faEye, faDotCircle, faTrashAlt, faStar as faStarOutline,
  faTimesCircle as faTimesCircleRegular, faMap, faCircle, faSquare, faHdd } from '@fortawesome/free-regular-svg-icons'
import { faEthernet, faPhone, faTv, faWifi, faMicrochip, faDoorOpen } from '@fortawesome/pro-regular-svg-icons'
import { faWall, faCameraBox, faCameraBullet, faCameraCovert, faCameraCube, faCameraDome,
  faCameraFisheye360, faCameraFisheye180, faCameraPtz, faCameraTurret, faCameraMultiImager,
  faSensor, faIntercom, faDesktop, faSpeaker } from 'helpers/customIcons'

library.add(
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faEdit,
  faSearch,
  faTimes,
  faImage,
  faFileArchive,
  faFileWord,
  faFilePowerpoint,
  faFilePdf,
  faFileExcel,
  faCopy,
  faLink,
  faPlus,
  faList,
  faFileDownload,
  faVideo,
  faBuilding,
  faEye,
  faTrashAlt,
  faLock,
  faUnlock,
  faExpandArrowsAlt,
  faMapMarkerAlt,
  faDotCircle,
  faPen,
  faArrowDown,
  faArrowUp,
  faArrowRight,
  faArrowLeft,
  faSync,
  faExternalLinkAlt,
  faStar,
  faStarOutline,
  faExclamationCircle,
  faCheckCircle,
  faInfoCircle,
  faBan,
  faCog,
  faComment,
  faBook,
  faFill,
  faHistory,
  faTimesCircleRegular,
  faChevronLeft,
  faLocationArrow,
  faMap,
  faSpinner,
  faSave,
  faCheck,
  faListUl,
  faExpand,
  faCompress,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faPortrait,
  faSlidersH,
  faClipboardList,
  faEllipsisV,
  faFont,
  faCircle,
  faDrawPolygon,
  faWaveSquare,
  faVectorSquare,
  faRoad,
  faSatellite,
  faSquare,
  faCalculator,
  faWall,
  faRulerCombined,
  fasCircle,
  faExclamationTriangle,
  faQuestionCircle,
  faServer,
  faTimesCircle,
  faNetworkWired,
  fasSquare,
  faCameraBox,
  faCameraBullet,
  faCameraCovert,
  faCameraCube,
  faCameraDome,
  faCameraFisheye180,
  faCameraFisheye360,
  faCameraPtz,
  faCameraTurret,
  faCameraMultiImager,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faEthernet,
  faSensor,
  faIntercom,
  faDesktop,
  faPhone,
  faTv,
  faHdd,
  faSpeaker,
  faWifi,
  faChevronDown,
  faChevronUp,
  faMicrochip,
  faDoorOpen
)



// WEBPACK FOOTER //
// ./src/helpers/fontAwesomeLibSetup.js